import React, { useContext } from 'react';
import styled from '@emotion/styled';

import { GlobalContext } from '../../contexts/global.context';

import './legend.styles.scss';

const LegendContainer = styled.div(props => ({
  display: props.display === 'map' ? 'flex': 'none',
  height: props.numBins * props.binHeight + 'px',
  "@media (max-width: 590px)": {
    height: props.numBins * (props.binHeight * 4/5) + 'px',
  },
}));

const LegendSquare = styled.div(props => ({
  height: props.binHeight,
  "@media (max-width: 590px)": {
    height: (props.binHeight * 4/5)
  },
}));

const LegendLabelsContainer = styled.div(props => ({
  marginTop: (props.binHeight / 2) + props.labelAdjustment,
  "@media (max-width: 590px)": {
    marginTop: ((props.binHeight * 4/5) / 2) + props.smallLabelAdjustment,
  },
}));

const LegendLabel = styled.div(props => ({
  height: props.binHeight,
  "@media (max-width: 590px)": {
    height: (props.binHeight * 4/5)
  },
}));

export default function Legend() {
  const { display, overlayBinThresholds, overlayExtraLegendInfo, overlayBinColors, getSelectorValueByIdFromTabInformation } = useContext(GlobalContext);
  const selectedRegions = getSelectorValueByIdFromTabInformation('regions') || [];
  if (selectedRegions.length === 0) {
    return '';
  }

  const comparison = getSelectorValueByIdFromTabInformation('overlayKey') || '';
  
  let legendUnit = '';
  let title = '';
  let labels = [];
  let shiftLabels = 0;
  if (overlayExtraLegendInfo !== null) {
    legendUnit = overlayExtraLegendInfo.isPercentage ? '%' : '';
    title = comparison ? overlayExtraLegendInfo.titleFn(comparison) : '';
    if (Object.keys(overlayExtraLegendInfo).includes('labelsFn')) {
      labels = comparison ? overlayExtraLegendInfo.labelsFn(comparison) : [];
    }
    if (Object.keys(overlayExtraLegendInfo).includes('shiftLabels')) {
      shiftLabels = overlayExtraLegendInfo.shiftLabels;
    }
  }

  const numBins = overlayBinColors ? overlayBinColors.length : 0;
  const binHeight = 300 / numBins;
  const labelAdjustment = shiftLabels + Math.max(0, 42 - 3 * numBins);
  const smallLabelAdjustment = shiftLabels + Math.max(0, 30 - 2 * numBins);
  
  const squares = overlayBinColors ? overlayBinColors.map(c => 
    <LegendSquare key={c} className='legend-square' binHeight={binHeight}>
      <div className='legend-square-spacer'></div>
      <div className='legend-square-color-block' style={{ backgroundColor: c }}></div>
    </LegendSquare>
  ) : [];

  if (overlayBinThresholds && ((Array.isArray(labels) && labels.length === 0) || labels === null || labels === undefined)) {
    labels = overlayBinThresholds;
  }

  labels = labels.map(t => <LegendLabel key={t} className='legend-label' binHeight={binHeight}>{t}{legendUnit}</LegendLabel>)

  return (
    <LegendContainer display={display} numBins={numBins} binHeight={binHeight} className='legend-container'>
      {comparison && <div className='legend-title'>{title}</div>}
      <div className='border-cover' />
      <LegendLabelsContainer className='legend-labels-container' labelAdjustment={labelAdjustment} smallLabelAdjustment={smallLabelAdjustment} binHeight={binHeight}>{labels}</LegendLabelsContainer>
      <div className='legend-squares-container'>{squares}</div>
    </LegendContainer>
  );
}
